var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Video",
    d: "M6.113 19.5A3.91 3.91 0 012 15.439V8.561A3.91 3.91 0 016.113 4.5h5.792a3.91 3.91 0 014.113 4.061v6.879a3.91 3.91 0 01-4.113 4.06zm13.844-2.38l-1.48-.747a1.624 1.624 0 01-.888-1.457V9.083a1.618 1.618 0 01.888-1.455l1.481-.749a1.384 1.384 0 011.373.064A1.432 1.432 0 0122 8.162v7.676a1.43 1.43 0 01-.669 1.219 1.4 1.4 0 01-.743.216 1.384 1.384 0 01-.631-.152z"
  })));
}
export default SvgVideoIcon;